import IComponent from "components/commons/IComponent";
import "./ZoomTo.scoped.css";
import LayerToggleUtil from "utils/LayerToggleUtil";
import geometryTools from "utils/geometryTools";
import slopeNoFormat from "utils/slopeNoFormat";

import SearchResult from "components/SearchResult/SearchResult";

import ZoomToLoc from "./ZoomToLoc";
import TextualSearch from "./TextualSearch";
import GraphicSearch from "./GraphicSearch";
import * as query from "@arcgis/core/rest/query.js";
import * as identify from "@arcgis/core/rest/identify.js";
import IdentifyParameters from "@arcgis/core/rest/support/IdentifyParameters.js";
import config_zoomto from "./config_zoomto";
import GetArcGISToken from "utils/GetArcGISToken";
import config_graphical_search from "./config_graphical_search";

class ZoomTo extends IComponent {
  searchWidget = null;
  highlightLayerForMMS = null;
  highlightLayerForDistrict = null;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.highlightLayerForMMS = geometryTools.createGraphicsLayerById(
      "highlightLayerForMMS",
      this.props.mapView.map
    );
    this.highlightLayerForDistrict = geometryTools.createGraphicsLayerById(
      "highlightLayerForDistrict",
      this.props.mapView.map
    );
  }
  componentWillUnmount() {}
  async graphicSearchCallback(searchInfo, geometry) {
    try {
      let category = searchInfo.type;
      let result;
      this.showLoadingDialog();
      switch (category) {
        case "mms":
          result = await this.queryForMMS(geometry);
          break;
        case "uav":
          result = await this.searchForUAV(geometry);
          break;
        case "giureport":
          result = await this.queryForGIUReportGraphical(searchInfo, geometry);
          break;
        default:
          if (Array.isArray(searchInfo)) {
            let allResult = await Promise.all(
              searchInfo.map((i) => this.identifyFeatureLayer(i, geometry))
            );
            console.debug(allResult);
            result = allResult.flat();
          } else result = await this.identifyFeatureLayer(searchInfo, geometry);
      }
      this.renderResult(result, "Identify Results", searchInfo);
    } catch (e) {
      console.debug("graphicSearchCallback Error", e);
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "Error occurred when searching for result",
        content: e.toString(),
        onDialogOk: () => {},
      });
    }
  }
  async textualSearchCallback(searchInfo, searchTerm) {
    try {
      this.showLoadingDialog();
      let searchResult = null;
      let searchType = searchInfo.type;
      switch (searchType) {
        case "mms":
          searchResult = await this.queryForMMS(searchTerm);
          if ("newFeatureResult" in searchResult) {
            this.renderResult(searchResult, "Textual Results", {
              name: "New Feature No.",
              itemDetailType: "newfeatno",
              displayField: "NEW_FEATREF",
            });
            return;
          }
          break;
        case "freeText":
          searchResult = await this.queryForFreeTextSearch(
            searchInfo,
            searchTerm
          );
          break;
        case "uav":
          console.debug("UAV Search?", searchTerm);
          let { textual_uav_from, textual_uav_to } = searchTerm;
          let yearList = Array.apply(
            null,
            Array(textual_uav_to - textual_uav_from + 1)
          ).map((i, j) => textual_uav_from + j);
          let queryPara = `SUBSTRING(datetaken FROM 1 FOR 4) in ('${yearList.join(
            "','"
          )}')`;
          searchResult = await this.searchForUAV(queryPara, "Textual Results");
          break;
        case "gireport":
          searchResult = await this.queryForGIUReportTextual(
            searchInfo,
            searchTerm
          );
          break;
        case "textualSearchLayer":
          searchResult = await this.queryTextualSearchLayer(
            searchInfo,
            searchTerm
          );
          break;
      }
      this.renderResult(searchResult, "Textual Results", searchInfo);
    } catch (e) {
      console.debug("textualSearchCallback Error", e);
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "Error occurred when searching for result",
        content: e.toString(),
        onDialogOk: () => {},
      });
    }
  }
  // 1. Search for user's input
  // 2. Remove certain part of use's input and try again
  // 3. Query for new feature numbers
  async queryForMMS(searchCriteria, newFeatureNo, userInput) {
    let targetSearchLayer = this.$config.mapList.mmsQueryLayer.layer;
    let queryPara = {
      returnGeometry: true,
      outFields: ["*"],
    };
    if (typeof searchCriteria === "string") {
      let scopeNo = slopeNoFormat.FeatureNo13Char(searchCriteria);
      queryPara.where = `SLOPE_NO = '${scopeNo}'`;
    } else if (Array.isArray(searchCriteria)) {
      let slopeList = searchCriteria.join("','");
      queryPara.where = `SLOPE_NO in ('${slopeList}')`;
    } else if (typeof searchCriteria === "object") {
      queryPara.spatialRelationship = "intersects";
      queryPara.geometry = searchCriteria;
    }
    var queryGeoResults = await this.nativeFeatureLayerQuery(
      targetSearchLayer,
      queryPara
    );

    if (
      typeof searchCriteria === "string" &&
      queryGeoResults.features.length === 0
    ) {
      if (typeof newFeatureNo === "undefined") {
        let newFNo = searchCriteria;
        if (searchCriteria.indexOf("/C ") > 0) {
          newFNo = searchCriteria.replace("/C ", "/CR");
        } else if (searchCriteria.indexOf("/CR") > 0) {
          newFNo = searchCriteria.replace("/CR", "/C ");
        } else if (searchCriteria.indexOf("/F ") > 0) {
          newFNo = searchCriteria.replace("/F ", "/FR");
        } else if (searchCriteria.indexOf("/FR") > 0) {
          newFNo = searchCriteria.replace("/FR", "/F ");
        }
        return this.queryForMMS(newFNo, newFNo, searchCriteria);
      } else {
        // Tried to replace
        let newFeatureResult = await this.fetchQueryByPOST(
          `${this.$config.webSrvUrl}WebAPI/GInfo/NewFeatures`,
          { Key: userInput }
        );
        newFeatureResult = await newFeatureResult.json();
        console.debug(newFeatureResult);
        if (newFeatureResult.length === 0) return { features: [] };
        return {
          newFeatureResult: true,
          features: newFeatureResult.map((i) => ({
            attributes: { NEW_FEATREF: i.NEW_FEATREF },
          })),
        };
      }
    }
    return queryGeoResults;
  }
  async queryForGIUReportTextual(searchInfo, searchValue) {
    let giResult = await this.fetchQueryByPOST(
      `${this.$config.webSrvUrl}WebAPI/GInfo/GIReports`,
      { ReportInfo: searchValue, Usergroup: GetArcGISToken.user.userGroup }
    );
    giResult = await giResult.json();
    console.debug(giResult);
    return { results: giResult.map((i) => ({ attributes: i.INFO })) };
  }
  async queryForFreeTextSearch(searchInfo, searchValue) {
    let category = searchInfo.name;
    let url = `${this.$config.webSrvUrl}WebAPI/GInfo/SurveyTextualSearch`;
    let Layer = null;
    switch (category) {
      case "Road / Building / Place":
        Layer = "";
        break;
      case "Lot Number":
        Layer = "LOT";
        break;
      case "Lamp Post":
        Layer = "UTILITY";
        break;
    }
    let MaxRecord = category === "Road / Building / Place" ? 500 : 1000;
    let queryPara = {
      Layer,
      SearchString: `${searchValue}`,
      Suggestion: "false",
      MaxRecord,
    };
    let placeResult = await this.fetchQueryByPOST(url, queryPara);
    placeResult = await placeResult.json();
    let finalResult = placeResult.results || [];
    if (category === "Road / Building / Place") {
      finalResult = finalResult.filter(
        (i) =>
          i.layerName == "ROAD" ||
          i.layerName == "BUILDING" ||
          i.layerName == "SITE"
      );
    }
    this.postProcessOfQueryGraphics(finalResult);
    return { results: finalResult };
  }
  async queryTextualSearchLayer(searchInfo, searchTerm) {
    searchTerm = searchTerm.toUpperCase();
    let isNumber = searchInfo.isNumberFields;
    let layerIds = Array.isArray(searchInfo.layerId)
      ? searchInfo.layerId
      : [searchInfo.layerId];
    let queryPara = {
      outFields: ["*"],
      returnGeometry: true,
    };
    let promises = layerIds.map((layerId, index, fullArray) => {
      let queryUrl = config_zoomto.TEXUAL_SEARCH_LAYER_URL + "/" + layerId;
      let likeSearch = searchInfo.searchType === "LIKE";
      let where = null;
      if (fullArray.length === 1)
        where = searchInfo.fields.map((i) => {
          if (isNumber) return `${i}=${searchTerm}`;
          else {
            i = `UPPER(${i})`;
            return likeSearch
              ? `${i} LIKE '%${searchTerm}%'`
              : `${i} = '${searchTerm}'`;
          }
        });
      else
        where = [
          likeSearch
            ? `${searchInfo.fields[index]} LIKE '%${searchTerm}%'`
            : `${searchInfo.fields[index]} = '${searchTerm}'`,
        ];
      if (searchInfo.searchType === "TEXT") queryPara.text = searchTerm;
      else queryPara.where = where.join(" OR ");
      return query.executeQueryJSON(queryUrl, queryPara, {
        userProxy: this.$config.useEsriProxy,
      });
    });
    let results = await Promise.all(promises);
    results = results.map((i, index) => {
      let layerInfo = config_zoomto.TEXTUAL_SEARCH_LAYER_NAME.find(
        (j) => j.id === layerIds[index]
      );
      console.debug(layerInfo);
      return {
        title: layerInfo.name,
        features: i.features,
        displayFieldName: i.displayFieldName,
      };
    });
    return results;
  }
  async identifyFeatureLayer(searchInfo, geometry) {
    let url = `${this.$config.serverUrl}/rest/services/GInfo/${
      searchInfo.layer
    }/MapServer`;
    let idParameter = new IdentifyParameters({
      geometry,
      width: this.props.mapView.container.clientWidth,
      height: this.props.mapView.container.clientHeight,
      // layerIds: [searchInfo.map((i) => i.layerId)],
      layerIds: searchInfo.layerId,
      layerOption: "all",
      tolerance: 10,
      returnGeometry: true,
      mapExtent: this.props.mapView.extent,
    });

    let identifyResult = await identify.identify(url, idParameter, {
      userProxy: this.$config.useEsriProxy,
    });
    let layerIdResultMapping = {};
    identifyResult.results.forEach((c) => {
      let resultInfo = layerIdResultMapping[c.layerId];
      if (!resultInfo) {
        resultInfo = layerIdResultMapping[c.layerId] = { ...c.toJSON() };
        delete resultInfo.geometry;
        delete resultInfo.attributes;
        resultInfo.results = [];
      }
      resultInfo.results.push(c.feature);
    });
    layerIdResultMapping = Object.values(layerIdResultMapping);
    console.debug(layerIdResultMapping);
    return layerIdResultMapping;
  }
  async queryForGIUReportGraphical(searchInfo, geometry) {
    let cells = await this.identifyFeatureLayer(searchInfo, geometry);
    let cellJoined = cells[0].results
      .map((i) => i.attributes.Sheet_no)
      .join("|");
    let giResult = await this.fetchQueryByPOST(
      `${this.$config.webSrvUrl}WebAPI/GInfo/GIReportsByCell`,
      { Key: cellJoined }
    );
    giResult = await giResult.json();
    console.debug(giResult);
    giResult = giResult.map((i) => ({ attributes: i }));
    giResult.push.apply(
      giResult,
      cells[0].results.map((i) => ({
        ignore: true,
        attributes: { REPNO: "DUMMY_CELL" },
        geometry: new geometryTools.Polygon(i.geometry),
      }))
    );
    return { results: giResult };
  }
  /**
   * Convert geometory JSON object to JSAPI's Gemoety object and add them to the map.
   * @param {*} queryGeoResults The search result object {features,[]}. Provide an empty array will clear the layer
   */
  postProcessOfQueryGraphics(queryGeoResults) {
    queryGeoResults.forEach((feature) => {
      switch (feature.geometryType) {
        case "esriGeometryPolyline":
          feature.geometry = new geometryTools.Polyline({
            paths: feature.geometry.paths,
            spatialReference: { wkid: 102140 },
          });
          break;
        case "esriGeometryPoint":
          feature.geometry = new geometryTools.Point({
            x: feature.geometry.x,
            y: feature.geometry.y,
            spatialReference: { wkid: 102140 },
          });
          break;
        default:
          feature.geometry = new geometryTools.Polygon({
            rings: feature.geometry.rings,
            spatialReference: { wkid: 102140 },
          });
          break;
      }
    });
  }
  renderResult(searchResultPara, type, searchInfo) {
    let searchResult2 = Array.isArray(searchResultPara)
      ? searchResultPara
      : [searchResultPara];
    let isCustomSearch = Array.isArray(searchInfo);
    let processedResult = searchResult2.map((searchResult) => {
      let resultToRender = [];
      let queryGeoResults = searchResult?.features || searchResult?.results;
      let displayField =
        searchInfo.displayField || searchResult.displayFieldName;
      // queryGeoResults.sort((a, b) =>
      //   a.attributes[displayField].localeCompare(b.attributes[displayField])
      // );
      queryGeoResults.forEach((textualResult) => {
        let displayValue = textualResult.attributes[displayField];
        resultToRender.push({
          key: displayValue,
          text: displayValue,
          attributes: textualResult.attributes,
          geometry: textualResult.geometry,
        });
      });

      let layerSearcInfo = isCustomSearch
        ? config_graphical_search.find(
            (i) => i.name === searchResult.layerName
          ) || {
            ...searchInfo,
            name: searchResult.layerName,
          }
        : searchInfo.name === "ENTLI"
        ? {
            ...searchInfo,
            name: searchResult.title,
          }
        : searchInfo;
      return {
        searchInfo: layerSearcInfo,
        results: resultToRender,
      };
    });
    SearchResult.updateSearchResultObject(
      processedResult,
      isCustomSearch,
      type
    );
    if (processedResult.every((i) => i.results.length === 0)) {
      this.props.showDialog({
        isOpen: true,
        title: "Search result",
        content: "No result found.",
        onDialogOk: () => {},
      });
      this.highlightLayerForMMS && this.highlightLayerForMMS.removeAll();
      this.highlightLayerForDistrict &&
        this.highlightLayerForDistrict.removeAll();
    } else {
      this.props.showDialog({
        isOpen: false,
      });
      this.props.switchPanel(3);
    }
  }
  showLoadingDialog() {
    this.props.showDialog({
      isOpen: true,
      title: "Search in progress",
      content: (
        <div>
          <span className="icn_loading" /> Loading...
        </div>
      ),
    });
  }
  makeUAVLayerReady() {
    var targetSearchLayer = [];
    ["UAV Image Point", "UAV Flight Path"].forEach((title) => {
      LayerToggleUtil.toggle3DLayer(
        "UAV",
        this.$config.mapList.layer3D.UAV.find((i) => i.title === title),
        true,
        this.props.mapView,
        false,
        true
      );
    });
    targetSearchLayer.push(
      this.props.mapView.map.allLayers.find(
        (i) => i.title?.toUpperCase().indexOf("UAV IMAGE POINT") > -1
      )
    );
    targetSearchLayer.push(
      this.props.mapView.map.allLayers.find(
        (i) => i.title?.toUpperCase().indexOf("UAV FLIGHT PATH") > -1
      )
    );
    return targetSearchLayer;
  }
  async searchForUAV(searchCriteria) {
    let targetSearchLayer = this.makeUAVLayerReady();
    let queryPara = {
      returnGeometry: false,
      outFields: ["*"],
      orderByFields: "DATETAKEN",
    };

    if (typeof searchCriteria === "string") {
      queryPara.where = searchCriteria;
    } else if (typeof searchCriteria === "object") {
      queryPara.spatialRelationship = "intersects";
      queryPara.geometry = searchCriteria;
    }

    let dateTimeCategory = [];
    let dateTimeDictionary = {};

    let layer = targetSearchLayer[0];
    let queryGeoResultsByGraphic = await this.nativeFeatureLayerQuery(
      layer,
      queryPara
    );
    if (queryGeoResultsByGraphic) {
      let definitionExpr = [];
      queryGeoResultsByGraphic.features.forEach((f) => {
        let siteName = f.attributes.SITENAME;
        let tmpDATETAKEN = f.attributes.DATETAKEN;
        let setKey = f.attributes.SETNUMBER;
        let uavSetKey = `${siteName} - ${setKey}`;
        if (!(uavSetKey in dateTimeDictionary)) {
          dateTimeDictionary[uavSetKey] = {
            attributes: {
              key: `${siteName} - ${tmpDATETAKEN}`,
              ...f.attributes,
            },
          };
          definitionExpr.push(
            `(SITENAME = '${siteName}' and SETNUMBER = '${setKey}')`
          );
        }
      });
      targetSearchLayer.forEach(
        (i) => (i.definitionExpression = definitionExpr.join(" or "))
      );
      dateTimeCategory = Object.values(dateTimeDictionary);

      let vm = this;
      setTimeout(async () => {
        let uavPtView = await this.props.mapView.whenLayerView(
          targetSearchLayer[0]
        );
        let watcher = uavPtView.watch("updating", async (newV) => {
          if (!newV) {
            watcher.remove();
            let geometry = await uavPtView.queryExtent({
              where: `1=1`,
            });
            geometry = geometry.extent;
            geometry.expand(1.5);
            geometryTools.zoomToGraphic(this.props.mapView, geometry);
            vm.props.showDialog({ isOpen: false });
          }
        });
      });
    }
    return { results: dateTimeCategory };
  }
  render() {
    return (
      <div className="ZoomToContainer">
        <ZoomToLoc {...this.props} />
        <TextualSearch
          {...this.props}
          onTextualSearch={this.textualSearchCallback.bind(this)}
        />
        <GraphicSearch
          {...this.props}
          onGraphicSearch={this.graphicSearchCallback.bind(this)}
        />
      </div>
    );
  }
}

export default ZoomTo;
